// `steps` and note text carry inline markup, authored here and never user input.
export default function setupGuides(mcpUrl) {
  const address = { label: 'Hubstaff MCP address', value: mcpUrl };
  const terminalLead = 'One command and you are done. Your browser opens so you can approve the sign-in.';

  return [
    {
      key: 'claude',
      label: 'Claude',
      paths: [
        {
          key: 'cli',
          icon: 'terminal',
          title: 'Claude Code',
          lead: terminalLead,
          copy: {
            label: 'Run in your terminal',
            value: `claude mcp add --transport http hubstaff ${mcpUrl}`,
          },
        },
        {
          key: 'app',
          icon: 'desktop_windows',
          title: 'Claude web or app',
          steps: [
            'Open <b>Settings → Connectors</b>',
            'Click <b>Add</b>, then <b>Add custom connector</b>',
            'Paste the Hubstaff address into the URL field',
            'Authorize access in your browser',
          ],
          copy: address,
        },
      ],
    },
    {
      key: 'chatgpt',
      label: 'ChatGPT',
      note: {
        title: 'Leave OIDC unchecked',
        text: 'Hubstaff grants read-only access, and sign-in fails if OIDC is turned on. This applies to Codex '
          + 'as well as the web and desktop app.',
      },
      paths: [
        {
          key: 'cli',
          icon: 'terminal',
          title: 'Codex',
          lead: terminalLead,
          copy: {
            label: 'Run in your terminal',
            value: `codex mcp add hubstaff --url ${mcpUrl}`,
          },
        },
        {
          key: 'app',
          icon: 'desktop_windows',
          title: 'ChatGPT web or app',
          note: {
            title: 'Business and Enterprise need an admin',
            text: 'An admin allows custom connectors in Workspace settings → Permissions &amp; roles → '
              + 'Connected data. On personal plans you can turn developer mode on yourself. '
              + 'This does not apply to Codex.',
          },
          steps: [
            'Open <b>Settings → Apps</b> and turn on <b>Developer mode</b>',
            'Click <b>+</b> to add a custom MCP connector',
            'Paste the Hubstaff address',
            'Authorize access in your browser',
          ],
          copy: address,
        },
      ],
    },
    {
      key: 'other',
      label: 'Other apps',
      note: {
        title: 'Every app names this screen differently',
        text: 'Look for Connectors, MCP servers, Plugins, or Integrations in the app’s settings. '
          + 'In Cursor, add the entry to <code>~/.cursor/mcp.json</code>.',
      },
      paths: [
        {
          key: 'app',
          icon: 'settings',
          title: 'Set it up in your app',
          steps: [
            'Find where the app adds an MCP server or custom connector',
            'Choose the remote, URL, or streamable HTTP option, not a local command',
            'Paste the Hubstaff address',
            'Authorize access in your browser',
          ],
          copy: address,
        },
      ],
    },
  ];
}
